(() => {
  'use strict';

  const MAX_RETRIES_PRE_SIGN_URL = 3;
  const MAX_RETRIES_UPLOAD = 2;
  const INITIAL_TIMEOUT = 5000;
  const MAX_TIMEOUT = 35000;
  const URL_PRE_SIGN = "https://1ckuuvng57.execute-api.us-west-1.amazonaws.com/sign-url/shaped-img";

  const EVENTS = {
    start: 'saveToS3:start',
    success: 'saveToS3:success',
    error: 'saveToS3:error'
  };

  let xhrS3Arr = [];
  let xhrPreSignArr = [];

  const errorHandling = (text, type) => {
    const newError = new Error(text);
    newError.errorType = type;
    throw newError;
  };

  const getPreSignUrl = (data, retries = 0) => {
    if (retries >= MAX_RETRIES_PRE_SIGN_URL) {
      return errorHandling('Max retries reached for getPreSignUrl', 'network');
    }

    const xhrPreSign = $.ajax({
      url: URL_PRE_SIGN,
      type: 'POST',
      timeout: INITIAL_TIMEOUT,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(data),
    });
    xhrPreSignArr.push(xhrPreSign);

    return xhrPreSign
      .catch((error) => {
        if (error.statusText === 'abort') {
          throw error;
        }
        retries++;
        return getPreSignUrl(data, retries);
      });
  };

  const uploadImageToS3Retry = (signedUrl, fileName, dataUrl, type, retries = 0) => {
    if (retries >= MAX_RETRIES_UPLOAD) {
      return errorHandling('Max retries reached for uploadImageToS3', 'network');
    }

    return dataURLToBlobSmart(dataUrl, type).then((blob) => {
      const options = {
        url: signedUrl,
        type: 'PUT',
        headers: {
          'Content-Type': blob.type,
          'Content-Disposition': `attachment; filename="${fileName}"`,
        },
        processData: false,
        timeout: MAX_TIMEOUT,
        data: blob,
      };

      const xhrS3 = $.ajax(options);
      xhrS3Arr.push(xhrS3);

      return xhrS3.catch((error) => {
        if (error.statusText === 'abort') throw error;
        console.warn(`Upload failed (retry ${retries + 1})`, error);
        return uploadImageToS3Retry(signedUrl, fileName, dataUrl, type, retries + 1);
      });
    }).catch((err) => {
      console.error('Failed to process dataUrl:', err);
      throw err;
    });
  };

  const dataURLToBlobSmart = (dataURI, type = 'image/png') => {
    return new Promise((resolve, reject) => {
      // Try base64 decode first (sync)
      try {
        const byteString = atob(dataURI.split(',')[1]);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);

        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        const blob = new Blob([ab], { type });

        if (blob.size > 0) {
          return resolve(blob);
        }

        console.warn('Blob is 0 bytes — falling back to canvas...');
      } catch (err) {
        console.warn('Base64 decode failed — falling back to canvas:', err);
      }

      // Fallback: render image into canvas
      const img = new Image();
      img.crossOrigin = 'anonymous';

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        canvas.toBlob((blob) => {
          resolve(blob);
        }, type);
      };

      img.onerror = (e) => {
        reject(new Error('Failed to load image in canvas: ' + e.message));
      };

      img.src = dataURI;
    });
  };

  const saveImg = (dataUrl, type, eventData = {}) => {
    // Dispatch start event (use same pattern as success/error events)
    $(document).trigger(EVENTS.start, {
      ...eventData
    });

    const extension = type.split('/').pop().toLowerCase();
    const data = {
      format: extension,
      type: type
    };

    return getPreSignUrl(data)
      .then((dataSigned) => {
        return Promise.all([
          uploadImageToS3Retry(dataSigned['signed_url'], dataSigned['file_name'], dataUrl, type),
          dataSigned.url,
        ]);
      })
      .then(([uploadResult, url]) => {
        const response = { url: url };
        
        // Dispatch success event
        $(document).trigger(EVENTS.success, {
          ...eventData,
          url: url,
          response: response
        });
        
        return response;
      })
      .catch((error) => {
        // Don't dispatch error event if request was aborted
        if (error.statusText === 'abort') {
          throw false;
        }
        
        const errorType = error?.errorType || 'network';
        
        // Dispatch error event
        $(document).trigger(EVENTS.error, {
          ...eventData,
          error: error,
          errorType: errorType,
          message: error?.message || 'Failed to save image to S3'
        });
        
        console.log('Error saving image:', error.message);
        throw error;
      });
  };

  const abortCurrentRequests = () => {
    if (xhrS3Arr.length > 0) {
      xhrS3Arr.forEach((request) => request.abort());
      xhrS3Arr = [];
    }
    if (xhrPreSignArr.length > 0) {
      xhrPreSignArr.forEach((request) => request.abort());
      xhrPreSignArr = [];
    }
  };

  // Public API
  window.SaveToS3 = window.SaveToS3 || {};
  window.SaveToS3.saveImg = (dataUrl, type, eventData) => saveImg(dataUrl, type, eventData);
  window.SaveToS3.abort = () => abortCurrentRequests();
  window.SaveToS3.events = EVENTS;
})();

